import { createActionGroup, props,  } from '@ngrx/store';

export const networkActions = createActionGroup({
  source: 'Network',
  events: {
       statusChanged: props<{ isOnline: boolean }>(),
  }
});
